import lodash from "lodash";
import { conditionFormChecker, putField, copyForm } from "../../../../../utils/form";
import {
    createFieldSelect,
    createFieldTemplateBuilder,
    createFieldRadioGroup,
    createFieldTextArea,
    createFieldInputNumber,
    createFieldInput
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { callCompanyType } from "../../../../account/register/register.section";
//import { createForm as createFormVessel } from "../../vessel/vessel.logic";
import {
    callSearchLicenseFull,
    callSearchLicense,
    callLifeStatus,
    callPersonType,
    callTitle,
    callNationality,
    createFieldAttorney,
    createFieldFishingArea,
    createFieldWorker,
    createFieldCancelRequest
} from "../license/request-license.section";
import { defineAsyncComponent } from "vue";
import {
    setKeepDataInputFromUserFillForm,
    setNullAfterSelectLicenseForRequest, setRequesterAddressFromCurrentUserAddress,
    setRequesterAddressFromLicense,
    setRequesterDetailFromCurrentUserInfo,
    setRequesterDetailFromLicenseOwnerDetail
} from "../license/request-license.logic";

export const callChangeLicenseObj = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group: "CHANGE_LICENSE_OBJECTIVE",
        value: searchQuery
    });

export const callFishingAreaRemark = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group: "CHANGE_FISHING_AREA_REMARK",
        value: searchQuery
    });

export const callReplaceShipRemark = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group: "REPLACE_SHIP_REMARK",
        value: searchQuery
    });

const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));

export const createFieldChangeRequestLicense = ({ props, data, key }) => {
    return putField({
        data,
        fields: [
            ...createFieldAttorney({ props, data, key }),
            ...createFieldFishingArea({ props, data, key }),
            ...createFieldWorker({ props, data, key }),
            ...createFieldCancelRequest({ props, data, key }),
        ]
    });
};

export const setValueByObjectiveRequest = ({ data, model }) => {
    if (!model.isOfficerCreate) {
        if (["editRegistration"].includes(model.refChangeLicenseObjective.key)) {
            setRequesterDetailFromCurrentUserInfo({ refRequestLicenseTemp: model });
        }
        else {
            if(model.refOriginal) {
                setRequesterDetailFromLicenseOwnerDetail({
                    refRequestLicenseTemp: model,
                    requestLicense: model.refOriginal
                });
            } else {
                setRequesterDetailFromLicenseOwnerDetail({
                    refRequestLicenseTemp: model,
                    requestLicense: data?.useForm?.initialModel
                });
            }
        }

    }
    if (["moveAshore"].includes(model.refChangeLicenseObjective?.key)) {
        const fishingArea = data.fishingArea.find((d) => d.key != model.refFishingArea?.key);
        model.refFishingArea = fishingArea;
    }
    if (["replaceBoat"].includes(model.refChangeLicenseObjective?.key)) {
        /* model.refVesselRequest.attachmentFullVessels.splice(0, model.refVesselRequest.attachmentFullVessels.length, {});
        model.refVesselRequest.attachmentHeadVessels.splice(0, model.refVesselRequest.attachmentHeadVessels.length, {});
        model.refVesselRequest.attachmentPositionVesselIdentities.splice(0, model.refVesselRequest.attachmentPositionVesselIdentities.length, {});
        model.refVesselRequest.attachmentVesselIdentities.splice(0, model.refVesselRequest.attachmentVesselIdentities.length, {}); */
        model.refVesselRequest.attachmentFullVessels.splice(0, model.refVesselRequest.attachmentFullVessels.length);
        model.refVesselRequest.attachmentHeadVessels.splice(0, model.refVesselRequest.attachmentHeadVessels.length);
        model.refVesselRequest.attachmentPositionVesselIdentities.splice(0, model.refVesselRequest.attachmentPositionVesselIdentities.length);
        model.refVesselRequest.attachmentVesselIdentities.splice(0, model.refVesselRequest.attachmentVesselIdentities.length)
        model.refVesselRequest.vesselOwnerRequests.splice(0, model.refVesselRequest.vesselOwnerRequests.length);
        model.refVesselRequest.breadth = null;
        model.refVesselRequest.code = null;
        model.refVesselRequest.deep = null;
        model.refVesselRequest.lbp = null;
        model.refVesselRequest.licenseExpireDate = null;
        model.refVesselRequest.licenseIssueDate = null;
        model.refVesselRequest.licenseNumber = null;
        model.refVesselRequest.loa = null;
        model.refVesselRequest.name = null;
        model.refVesselRequest.refBoatLicenseStatus = null;
        model.refVesselRequest.registrationDate = null;
        model.refVesselRequest.tgross = null;
        model.refVesselRequest.tnange = null;
        model.refVesselRequest.useType = null;
        model.refVesselRequest.vesselType = null;
        setTimeout(() => {model.refVesselRequest.attachmentFullVessels.push({})}, 0);
        setTimeout(() => {model.refVesselRequest.attachmentHeadVessels.push({})}, 0);
        setTimeout(() => {model.refVesselRequest.attachmentPositionVesselIdentities.push({})}, 0);
        setTimeout(() => {model.refVesselRequest.attachmentVesselIdentities.push({})}, 0);
    }
};

/*
export const checkAndClearDataWhenChangeObjective = ({ model, changeObjective }) => {
    if ("tool" == changeObjective.key) {
        model.reasonReplace = null;
        model.refReplaceShipRemark = null;
        model.otherRemark = null;
        model.refChangeFishingAreaRemark = null;
        model.dockReplaceShip = null;
        model.movingShipMode = null;
    }

    if ("moveAshore"  == changeObjective.key) {
        model.reasonReplace = null;
        model.refReplaceShipRemark = null;
        model.dockReplaceShip = null;
    }
}
*/


export const createFieldChangeLicense = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const userInfo = store.state.resource.auth.info?.user;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}changeDetailSection`,
                cardBorderProp: () => ({
                    bodyStyle: { paddingLeft: '0px' },
                    title: i18n.global.t("views.request.licenseRequest.requestPurpose.changeRequest"),
                    headerSize: "small"
                }),
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                colProp: () => ({ xs: 24, class: "mt-4" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({
                        data,
                        fields: [
                            createFieldSelect({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}refOriginal`,
                                colProp: () => ({ xs: 24, md: 12 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                                label: () => i18n.global.t("model.licenseRequest.refOriginal"),
                                inputProp: ({ field }) => {
                                    return lodash.merge(
                                        {
                                            value: model.refOriginal,
                                            "onUpdate:value": (value) => {
                                                const oldValue = model.refOriginal;
                                                model.refOriginal = value;
                                                if (oldValue) {
                                                    Modal.confirm({
                                                        title: i18n.global.t("views.request.modal.change", {
                                                            text: i18n.global.t("views.request.licenseRequest.modal.confirmChangeLicense")
                                                        }),
                                                        autoFocusButton: "cancel",
                                                        onOk: () => {
                                                            callRequestLicenseById({ model, id: value?.id });
                                                        },
                                                        onCancel: () => {
                                                            model.refOriginal = oldValue;
                                                        }
                                                    });
                                                } else {
                                                    callRequestLicenseById({ model, id: value?.id });
                                                }
                                            },
                                            disabled: viewOnly,
                                            list: ({ searchQuery }) =>
                                                callSearchLicense({
                                                    searchQuery,
                                                    userInfo,
                                                    props,
                                                    refLicenseStatusKey: "active",
                                                    data
                                                }),
                                            optLabel: "licenseCode",
                                            allowClear: false
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    );
                                },
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                            }),
                            createFieldSelect({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field, model }
                                }),
                                key: `${prefix}refChangeLicenseObjective`,
                                colProp: () => ({ xs: 24, md: 12 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.refChangeLicenseObjective")}`,
                                inputProp: ({ field }) => {
                                    return lodash.merge(
                                        {
                                            value: model.refChangeLicenseObjective,
                                            "onUpdate:value": (value) => {
                                                menuContext.tabKeyRequester = "Requester";
                                                const oldValue = model.refChangeLicenseObjective;
                                                model.refChangeLicenseObjective = value;
                                                if (oldValue) {
                                                    Modal.confirm({
                                                        title: i18n.global.t("views.request.modal.change", {
                                                            text: i18n.global.t("model.licenseRequest.refChangeLicenseObjective")
                                                        }),
                                                        autoFocusButton: "cancel",
                                                        onOk: () => {
                                                            // callRequestLicenseById({
                                                            //     model,
                                                            //     id: model.refOriginal?.id,
                                                            // });
                                                            const cloneInitialModel = lodash.cloneDeep(useForm.initialModel)
                                                            cloneInitialModel.refChangeLicenseObjective = value;
                                                            model.attachments = [];
                                                            data.licenseRequestAttachment.forEach((item) => {
                                                                if (!item.attribute?.objectiveRequest) {
                                                                    model.attachments.push({
                                                                        keyAttachment: item.key,
                                                                        documentName: item.value,
                                                                        attribute: lodash.cloneDeep(item.attribute),
                                                                        group: "LicenseRequestAttachment"
                                                                    });
                                                                } else if (model.refChangeLicenseObjective.key.includes(item.attribute?.objectiveRequest)) {
                                                                    model.attachments.push({
                                                                        keyAttachment: item.key,
                                                                        documentName: item.value,
                                                                        attribute: lodash.cloneDeep(item.attribute),
                                                                        group: "LicenseRequestAttachment"
                                                                    });
                                                                }
                                                            });
                                                            setValueByObjectiveRequest({ data, model: cloneInitialModel, userInfo });
                                                            callEditChangeObjective({ model, initialModel: cloneInitialModel })
                                                        },
                                                        onCancel: () => {
                                                            model.refChangeLicenseObjective = oldValue;
                                                        }
                                                    });
                                                }
                                                else {
                                                    model.refChangeLicenseObjective = value;
                                                    // data.licenseRequestAttachment.forEach((item) => {
                                                    //     if (model.refChangeLicenseObjective.key.includes(item.attribute?.objectiveRequest)) {
                                                    //         model.attachments.push({
                                                    //             keyAttachment: item.key,
                                                    //             documentName: item.value,
                                                    //             attribute: lodash.cloneDeep(item.attribute),
                                                    //             group: "LicenseRequestAttachment"
                                                    //         });
                                                    //     }
                                                    // });

                                                    data.licenseRequestAttachment.forEach((item) => {
                                                        if (!item.attribute?.objectiveRequest) {
                                                            model.attachments.push({
                                                                keyAttachment: item.key,
                                                                documentName: item.value,
                                                                attribute: lodash.cloneDeep(item.attribute),
                                                                group: "LicenseRequestAttachment"
                                                            });
                                                        } else if (model.refChangeLicenseObjective.key.includes(item.attribute?.objectiveRequest)) {
                                                            model.attachments.push({
                                                                keyAttachment: item.key,
                                                                documentName: item.value,
                                                                attribute: lodash.cloneDeep(item.attribute),
                                                                group: "LicenseRequestAttachment"
                                                            });
                                                        }
                                                    });


                                                    setValueByObjectiveRequest({ data, model: model, userInfo });
                                                }
                                            },
                                            disabled: viewOnly,
                                            list: callChangeLicenseObj,
                                            optLabel: "value"
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    );
                                },
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                            }),
                            createFieldTextArea({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}reasonReplace`,
                                colProp: () => ({ xs: 24 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                                label: () => i18n.global.t("views.request.licenseRequest.reasonReplace"),
                                labelRender: () =>
                                    <span>{i18n.global.t("views.request.licenseRequest.reasonReplaceRender")}</span>,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.reasonReplace,
                                            "onUpdate:value": (value) => (model.reasonReplace = value),
                                            disabled: viewOnly
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    )
                            }),
                            createFieldTextArea({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}dockReplaceShip`,
                                colProp: () => ({ xs: 24 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                                label: () => i18n.global.t("views.request.licenseRequest.dockReplaceShip"),
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.dockReplaceShip,
                                            "onUpdate:value": (value) => (model.dockReplaceShip = value),
                                            disabled: viewOnly
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    )
                            }),
                            createFieldRadioGroup({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}refChangeFishingAreaRemark`,
                                colProp: () => ({ xs: 24 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                                label: () => i18n.global.t("views.request.licenseRequest.refChangeFishingAreaRemark"),
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.refChangeFishingAreaRemark,
                                            "onUpdate:value": (value) => {
                                                model.refChangeFishingAreaRemark = value;
                                                model.otherRemark = null;
                                            },
                                            disabled: viewOnly,
                                            list: callFishingAreaRemark,
                                            optLabel: "value",
                                            type: "vertical"
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                            }),
                            createFieldRadioGroup({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}refReplaceShipRemark`,
                                colProp: () => ({ xs: 24 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                                label: () => i18n.global.t("views.request.licenseRequest.refReplaceShipRemark"),
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.refReplaceShipRemark,
                                            "onUpdate:value": (value) => {
                                                model.refReplaceShipRemark = value;
                                                model.otherRemark = null;
                                            },
                                            disabled: viewOnly,
                                            list: callReplaceShipRemark,
                                            optLabel: "value",
                                            type: "vertical"
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
                            }),
                            createFieldTextArea({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}otherRemark`,
                                colProp: () => ({ xs: 24 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                                label: () => i18n.global.t("views.request.licenseRequest.otherRemark"),
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.otherRemark,
                                            "onUpdate:value": (value) => (model.otherRemark = value),
                                            disabled: viewOnly
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    )
                            }),
                            createFieldTextArea({
                                visible: ({ field }) => conditionFormChecker({
                                    props,
                                    data,
                                    executeKey: "visibleField",
                                    params: { field }
                                }),
                                key: `${prefix}movingShipMode`,
                                colProp: () => ({ xs: 24 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                                label: () => i18n.global.t("views.request.licenseRequest.movingShipMode"),
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.movingShipMode,
                                            "onUpdate:value": (value) => (model.movingShipMode = value),
                                            disabled: viewOnly
                                        },
                                        conditionFormChecker({
                                            props,
                                            data,
                                            executeKey: "inputPropField",
                                            params: { field }
                                        })
                                    )
                            })
                        ]
                    })
                })
            })
        ]
    });
};

export const createFieldRefOriginalRequester = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.refRequesterPersonType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refPersonType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refRequesterPersonType,
                            "onUpdate:value": (value) => (model.refOriginal.refRequesterPersonType = value),
                            disabled: viewOnly,
                            list: callPersonType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.requesterIdCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    modelRef.refOriginal?.refRequesterPersonType?.key == "2"
                        ? `${i18n.global.t("model.licenseRequest.requesterIdCard")}`
                        : `${i18n.global.t("model.licenseRequest.taxId")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterIdCard,
                            "onUpdate:value": (value) => (model.refOriginal.requesterIdCard = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.requesterName`,
                colProp: () => ({ xs: 24, md: 24 ,style: { paddingLeft: "8px !important" }}),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterName,
                            "onUpdate:value": (value) => (model.refOriginal.requesterName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.refRequesterCompanyType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refRequesterCompanyType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refRequesterCompanyType,
                            "onUpdate:value": (value) => (model.refOriginal.refRequesterCompanyType = value),
                            disabled: viewOnly,
                            list: callCompanyType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.requesterShareholdingTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.requesterShareholdingTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterShareholdingTh,
                            "onUpdate:value": (value) => {
                                model.refOriginal.requesterShareholdingTh = value > 100 ? 100 : value;
                            },
                            disabled: viewOnly,
                            comma: true,
                            maxDecimal: 3,
                            allowPrecision: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.refRequesterTitle`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refRequesterTitle")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refRequesterTitle,
                            "onUpdate:value": (value) => (model.refOriginal.refRequesterTitle = value),
                            disabled: viewOnly,
                            list: callTitle,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refOriginal.requesterFirstNameSpace`,
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                colProp: () => ({ md: 12, xs: 0 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.requesterFirstName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterFirstName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterFirstName,
                            "onUpdate:value": (value) => {
                                model.refOriginal.requesterFirstName = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.requesterLastName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterLastName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterLastName,
                            "onUpdate:value": (value) => (model.refOriginal.requesterLastName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.requesterAge`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterAge")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterAge,
                            "onUpdate:value": (value) => (model.refOriginal.requesterAge = value),
                            disabled: true,
                            addonAfter: "ปี"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.refRequesterNationality`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refNationality")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refRequesterNationality,
                            "onUpdate:value": (value) => (model.refOriginal.refRequesterNationality = value),
                            disabled: true,
                            list: callNationality,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.requesterEmail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterEmail,
                            "onUpdate:value": (value) => (model.refOriginal.requesterEmail = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.requesterMobile`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.mobile"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.requesterMobile,
                            "onUpdate:value": (value) => (model.refOriginal.requesterMobile = value),
                            comma: false,
                            maxDecimal: 10
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refRequesterLifeStatus`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refRequesterLifeStatus"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequesterLifeStatus,
                            "onUpdate:value": (value) => (model.refRequesterLifeStatus = value),
                            disabled: viewOnly,
                            list: callLifeStatus,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refOriginal.addresses.0`,
                visible: () => true,
                colProp: () => ({
                    xs: 24,
                    md: 24,
                    style: { alignSelf: "center", padding: "0px" },
                    class: "hr-address-label"
                }),
                formItemProp: () => ({
                    labelCol: { xs: 24, md: 3, style: { paddingTop: "0px" } },
                    wrapperCol: { xs: 24, md: 21 }
                }),
                label: () => <label style={{
                    paddingTop: "0px !important",
                    fontWeight: "bold"
                }}>{i18n.global.t("model.address.modelName")}</label>,
                inputRender: () => (
                    <hr
                        style={{
                            borderTop: "2px dashed #fff",
                            borderBottom: "1px dashed #8c8b8b"
                        }}
                    ></hr>
                )
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                // formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                // label: () => i18n.global.t("model.address.modelName"),
                inputRender: () => {
                    model?.refOriginal?.addresses?.[0]?.id;
                    return () =>
                        !model?.refOriginal?.addresses ? (
                            <></>
                        ) : (
                            <Address
                                menuContext={menuContext}
                                viewOnly={viewOnly}
                                dataProp={data}
                                dataKey={`${prefix}refOriginal.addresses.0`}
                                isLoading={isLoading.value}
                            ></Address>
                        );
                }
                // inputRender: () => (
                //     <Address
                //         menuContext={menuContext}
                //         viewOnly={viewOnly}
                //         dataProp={data}
                //         dataKey={`${prefix}refOriginal.addresses.0`}
                //         isLoading={isLoading.value}
                //     ></Address>
                // ),
            }
        ]
    });
};

export const createFieldRefOriginalOwner = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.refOwnerPersonType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refPersonType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refOwnerPersonType,
                            "onUpdate:value": (value) => (model.refOriginal.refOwnerPersonType = value),
                            disabled: viewOnly,
                            list: callPersonType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.ownerIdCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    modelRef.refOriginal?.refOwnerPersonType?.key == "2"
                        ? `${i18n.global.t("model.licenseRequest.ownerIdCard")}`
                        : `${i18n.global.t("model.licenseRequest.taxId")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerIdCard,
                            "onUpdate:value": (value) => (model.refOriginal.ownerIdCard = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.ownerName`,
                colProp: () => ({ xs: 24, md: 24 ,style: { paddingLeft: "8px !important" }}),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerName,
                            "onUpdate:value": (value) => (model.refOriginal.ownerName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.refOwnerCompanyType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refOwnerCompanyType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refOwnerCompanyType,
                            "onUpdate:value": (value) => (model.refOriginal.refOwnerCompanyType = value),
                            disabled: viewOnly,
                            list: callCompanyType,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.ownerShareholdingTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.ownerShareholdingTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerShareholdingTh,
                            "onUpdate:value": (value) => {
                                model.refOriginal.ownerShareholdingTh = value > 100 ? 100 : value;
                            },
                            disabled: viewOnly,
                            comma: true,
                            maxDecimal: 3,
                            allowPrecision: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.refOwnerTitle`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refOwnerTitle")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refOwnerTitle,
                            "onUpdate:value": (value) => (model.refOriginal.refOwnerTitle = value),
                            disabled: viewOnly,
                            list: callTitle,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            {
                key: `${prefix}refOriginal.ownerFirstNameSpace`,
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                colProp: () => ({ md: 12, xs: 0 }),
                formItemRender: () => {
                }
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.ownerFirstName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerFirstName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerFirstName,
                            "onUpdate:value": (value) => {
                                model.refOriginal.ownerFirstName = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.ownerLastName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerLastName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerLastName,
                            "onUpdate:value": (value) => (model.refOriginal.ownerLastName = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.ownerAge`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerAge")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerAge,
                            "onUpdate:value": (value) => (model.refOriginal.ownerAge = value),
                            disabled: true,
                            addonAfter: "ปี"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field, model }
                }),
                key: `${prefix}refOriginal.refOwnerNationality`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refOwnerNationality")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refOwnerNationality,
                            "onUpdate:value": (value) => (model.refOriginal.refOwnerNationality = value),
                            disabled: true,
                            list: callNationality,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.ownerEmail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerEmail,
                            "onUpdate:value": (value) => (model.refOriginal.ownerEmail = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({
                    props,
                    data,
                    executeKey: "visibleField",
                    params: { field }
                }),
                key: `${prefix}refOriginal.ownerMobile`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.mobile"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.ownerMobile,
                            "onUpdate:value": (value) => (model.refOriginal.ownerMobile = value),
                            comma: false,
                            maxDecimal: 10
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                key: `${prefix}refOriginal.addressOwners.0`,
                visible: () => true,
                colProp: () => ({
                    xs: 24,
                    md: 24,
                    style: { alignSelf: "center", padding: "0px" },
                    class: "hr-address-label"
                }),
                formItemProp: () => ({
                    labelCol: { xs: 24, md: 3, style: { paddingTop: "0px" } },
                    wrapperCol: { xs: 24, md: 21 }
                }),
                label: () => <label style={{
                    paddingTop: "0px !important",
                    fontWeight: "bold"
                }}>{i18n.global.t("model.address.modelName")}</label>,
                inputRender: () => (
                    <hr
                        style={{
                            borderTop: "2px dashed #fff",
                            borderBottom: "1px dashed #8c8b8b"
                        }}
                    ></hr>
                )
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                // formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                // label: () => i18n.global.t("model.address.modelName"),
                inputRender: () => {
                    model?.refOriginal?.addressOwners?.[0]?.id;
                    return () =>
                        !model?.refOriginal?.addressOwners ? (
                            <></>
                        ) : (
                            <Address
                                menuContext={menuContext}
                                viewOnly={viewOnly}
                                dataProp={data}
                                dataKey={`${prefix}refOriginal.addressOwners.0`}
                                isLoading={isLoading.value}
                            ></Address>
                        );
                }
                // inputRender: () => (
                //     <Address
                //         menuContext={menuContext}
                //         viewOnly={viewOnly}
                //         dataProp={data}
                //         dataKey={`${prefix}refOriginal.addresses.0`}
                //         isLoading={isLoading.value}
                //     ></Address>
                // ),
            }
        ]
    });
};


export const callEditChangeObjective = ({ model, initialModel }) => {
    setIsLoadingApp(true);
    if (model.id) {
        setIsLoadingApp(false);
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ form: initialModel }) },
            query: { _timestamp: new Date().getTime() },
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() },
        });
    }
};

export const callRequestLicenseById = ({ model, id }) => {
    setIsLoadingApp(true);
    if (id) {
        callSearchLicenseFull({ id }).then((requestLicense) => {
            const refRequestLicenseTemp = copyForm({
                form: {
                    ...requestLicense,
                    refOriginal: requestLicense
                }
            });
            setIsLoadingApp(false);
            if (id) {
                setNullAfterSelectLicenseForRequest({ refRequestLicenseTemp });
                /* model = ที่กรอกไปแล้วก่อนเลือกใบอนุญาต + ที่โหลด Default Value ที่ถูก Set มาจาก Load Default Form */
                setKeepDataInputFromUserFillForm({ refRequestLicenseTemp, keyIn: model });
                if (model.refFishingArea && ["moveAshore"].includes(model.refChangeLicenseObjective.key)) {
                    refRequestLicenseTemp.refFishingArea = model.refFishingArea;
                }
                if (model.isOfficerCreate) {
                    setRequesterDetailFromLicenseOwnerDetail({ refRequestLicenseTemp, requestLicense });
                    setRequesterAddressFromLicense({ refRequestLicenseTemp, requestLicense });
                } else {
                    if (refRequestLicenseTemp.refChangeLicenseObjective?.key == "editRegistration") {
                        setRequesterDetailFromCurrentUserInfo({ refRequestLicenseTemp });
                        setRequesterAddressFromCurrentUserAddress({ refRequestLicenseTemp });
                    } else {
                        setRequesterDetailFromLicenseOwnerDetail({ refRequestLicenseTemp, requestLicense });
                        setRequesterAddressFromCurrentUserAddress({ refRequestLicenseTemp });
                    }
                }
                const refVesselRequestTemp = copyForm({ form: { ...requestLicense.refVesselRequest } });
                refVesselRequestTemp.refOriginal = requestLicense.refVesselRequest;
                refVesselRequestTemp.vesselOwnerRequests?.forEach(
                    (d, index) => (d.refOriginal = { id: requestLicense.refVesselRequest.vesselOwnerRequests[index].id })
                );
                refRequestLicenseTemp.fishingToolRequests?.forEach((d, index) => {
                    d.refOriginal = { ...lodash.cloneDeep(requestLicense.fishingToolRequests[index]), isChange: false };
                    d.isChange = false;
                });
                //ส่วน attachmentVessel
                refVesselRequestTemp.attachmentVesselIdentities?.forEach(
                    (d, index) => (d.refRealId = requestLicense.refVesselRequest.attachmentVesselIdentities[index].id)
                );
                refVesselRequestTemp.attachmentPositionVesselIdentities?.forEach(
                    (d, index) => (d.refRealId = requestLicense.refVesselRequest.attachmentPositionVesselIdentities[index].id)
                );
                refVesselRequestTemp.attachmentHeadVessels?.forEach(
                    (d, index) => (d.refRealId = requestLicense.refVesselRequest.attachmentHeadVessels[index].id)
                );
                refVesselRequestTemp.attachmentFullVessels?.forEach(
                    (d, index) => (d.refRealId = requestLicense.refVesselRequest.attachmentFullVessels[index].id)
                );
                refRequestLicenseTemp.refVesselRequest = refVesselRequestTemp;

            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...refRequestLicenseTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    }
    else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

// export const copyRequestLicense = ({ model }) => {
//     const refOriginal = model.refOriginal;
//     model.refFishingArea = refOriginal.refFishingArea;
//     model.refVesselRequest = refOriginal.refVesselRequest;
//     model.fishingToolRequests = refOriginal.fishingToolRequests;
// };
